module.exports = __webpack_public_path__ + "static/img/hand.be8aceab.gif";